<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <!--
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">Spotify</v-btn>
      </template>
      -->
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Spotify</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false">Fechar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-card :loading="loading" class="mx-auto my-12" :max-width="width">
          <iframe :src="link" :width="width" height="580" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      loading: false,
      link:
        "https://open.spotify.com/embed/playlist/0mHEU5iDotUGSrm7RCeEC5",
      width: 500
    };
  },
  created: function() {
    if (window.innerHeight <= 500) {
      this.width = window.innerHeight - 10;
    }
  },
  watch: {
    IsSpotify(val) {
      if (!val) return;

      if (val == true) {
        this.dialog = true;

        this.$store.commit("setIsSpotify", false);
      }
    }
  },
  computed: mapState([
    // map this.count to store.state.count
    "IsSpotify",
    "IsMobile"
  ])
};
</script>

<style></style>
